import { render, staticRenderFns } from "./vipDetailRefundOrder.vue?vue&type=template&id=fb33aa16&scoped=true"
import script from "./vipDetailRefundOrder.vue?vue&type=script&lang=js"
export * from "./vipDetailRefundOrder.vue?vue&type=script&lang=js"
import style0 from "./vipDetailRefundOrder.vue?vue&type=style&index=0&id=fb33aa16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb33aa16",
  null
  
)

export default component.exports